function About() {
  return <h1>About stranica</h1>;
}

export default About;